<script>
  import { fade, fly, blur, slide, scale } from "svelte/transition";

  const buttons = [
    {
      titre: "Tdb appt",
      color: "green",
      href: "/recap",
      comment: "Synthèse APPT",
      actif: true,
    },
    {
      titre: "Liste appt",
      color: "green",
      href: "/loyers",
      comment: "",
      actif: true,
    },
    {
      titre: "Loyers appt",
      color: "green",
      href: "/loyers",
      comment: "",
      actif: true,
    },
    {
      titre: "Emprunts",
      color: "green",
      href: "/emprunt",
      comment: "",
      actif: true,
    },
    {
      titre: "Détail car",
      color: "orange",
      href: "/carsdetail",
      comment: "",
      actif: true,
    },
    {
      titre: "Dépenses",
      color: "orange",
      href: "/depenses",
      comment: "",
      actif: true,
    },
    {
      titre: "Liste bk",
      color: "blue",
      href: "/listebybk",
      comment: "",
      actif: true,
    },
    {
      titre: "Liste opvcm",
      color: "blue",
      href: "/listeopvcm",
      comment: "",
      actif: true,
    },
    {
      titre: "Liste bricks",
      color: "blue",
      href: "/brickssynthese",
      comment: "",
      actif: true,
    },
    {
      titre: "graphe EDF",
      color: "red",
      href: "/graphedf",
      comment: "",
      actif: true,
    },
    {
      titre: "graphe Tx froncière",
      color: "red",
      href: "/graphtxfronciere",
      comment: "",
      actif: true,
    },
    {
      titre: "graphe BK",
      color: "red",
      href: "/bank",
      comment: "",
      actif: true,
    },
    {
      titre: "graphe By bénéf.",
      color: "red",
      href: "/graphbybenef",
      comment: "",
      actif: true,
    },
    {
      titre: "Restau.",
      color: "yellow",
      href: "/restau",
      comment: "",
      actif: true,
    },
    {
      titre: "Recettes",
      color: "yellow",
      href: "/recettes",
      comment: "",
      actif: true,
    },
    {
      titre: "Recettes photos",
      color: "yellow",
      href: "/photo",
      comment: "",
      actif: true,
    },
    {
      titre: "H. piscine",
      color: "yellow",
      href: "/piscine",
      comment: "",
      actif: true,
    },
    {
      titre: "Films",
      color: "yellow",
      href: "/films",
      comment: "",
      actif: true,
    },
    {
      titre: "Cocktails",
      color: "yellow",
      href: "/cocktail",
      comment: "",
      actif: true,
    },
  ];
</script>

<div class="row">
  {#each buttons as button}
    <div
      class="col-sm-4"
      in:slide={{ delay: 250, duration: 600 }}
      out:fade={{ delay: 250, duration: 300 }}
    >
      <a href="/#{button.href}" tilte="{button.titre}">
        <div class="tile {button.color}">
          <h3 class="title">{button.titre}</h3>
          <p>{button.comment}</p>
        </div>
    </a>
    </div>
  {/each}
</div>

<style>
  p
 {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  h3 {
    font-family: "Open Sans", "Segoe UI", Frutiger, "Frutiger Linotype",
      "Dejavu Sans", "Helvetica Neue", Arial, sans-serify;
    line-height: 1.5em;
    font-weight: 150;
  }

  .tile {
    width: 100%;
    display: inline-block;
    box-sizing: border-box;
    background: #fff;
    padding: 20px;
    margin-bottom: 30px;
  }

  .title {
    margin-top: 0px;
  }

  .purple,
  .blue,
  .red,
  .orange,
  .green,
  .hellow {
    color: #fff;
  }

  .yellow {
    background: #d0cb3c;
  }

  .yellow:hover {
    background: darken(#d0cb3c, 10%);
  }

  .purple {
    background: #5133ab;
  }

  .purple:hover {
    background: darken(#5133ab, 10%);
  }

  .red {
    background: #ac193d;
  }

  .red:hover {
    background: darken(#ac193d, 10%);
  }

  .green {
    background: #00a600;
  }

  .green:hover {
    background: darken(#00a600, 10%);
  }

  .blue {
    background: #2672ec;
  }

  .blue:hover {
    background: darken(#2672ec, 10%);
  }

  .orange {
    background: #dc572e;
  }

  .orange:hover {
    background: darken(#dc572e, 10%);
  }
</style>
